import { Action, createReducer, on } from '@ngrx/store';
import { ClassifyActions } from '.';
import { StateBuilder } from '../../../model/state.builder';
import { IClassifyState } from './classify.state';

export const initialClassifyState: IClassifyState = {
  model: undefined,
  data: undefined,
  uiState: undefined
};

const classifyReducerFn = createReducer(
  initialClassifyState,
  on(ClassifyActions.submit, (state: IClassifyState) => {
    return new StateBuilder<IClassifyState>(state).toLoading().build();
  }),
  on(ClassifyActions.submitSuccess, (state: IClassifyState, action) => {
    return new StateBuilder<IClassifyState>(state, action).toLoaded().build();
  })
);

export function classifyReducer(state: IClassifyState | undefined, action: Action) {
  return classifyReducerFn(state, action);
}
